import { MediaItemCardWithActionsInnerChild } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActionsInnerChild";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import CrossSmallPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossSmallPath";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import SmallPlusIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/SmallPlusIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import styles from "./backup-product-section.module.css";

type BackupProductSectionProps = {
  backupProduct?: Item | null;
  onSelect: () => void;
  onRemove: () => void;
};

export const BackupProductSection = ({
  backupProduct,
  onSelect,
  onRemove,
}: BackupProductSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["section"]} data-testid="backup-product-section">
      <div className={styles["connector"]} aria-hidden="true" />

      <div className={styles["content"]}>
        <FixaText tagName="h3" textStyle="Label.S" className={styles["label"]}>
          {t("backupProductString")}
        </FixaText>

        {backupProduct ? (
          <div
            className={styles["selected"]}
            data-testid="backup-product-selected"
          >
            <div className={styles["selectedInfo"]}>
              <MediaItemCardWithActionsInnerChild
                item={backupProduct}
                articleHfb={backupProduct.hfbNo}
                itemCardRenderType={ItemCardRenderType.static}
              />
            </div>
            <div className={styles["selectedActions"]}>
              <FixaButton
                className={styles["changeButton"]}
                type="plain"
                text={t("changeTeamString")}
                onClick={onSelect}
              />
              <FixaButton
                className={styles["removeButton"]}
                type="plain"
                iconOnly
                ssrIcon={CrossSmallPath}
                aria-label={t("removeString")}
                onClick={onRemove}
              />
            </div>
          </div>
        ) : (
          <button
            type="button"
            className={styles["selectButton"]}
            onClick={onSelect}
          >
            <FixaSSRIcon paths={SmallPlusIconPath} />
            <FixaText tagName="p" textStyle="Label.M">
              {t("selectBackupProductString")}
            </FixaText>
          </button>
        )}
      </div>
    </div>
  );
};
